import { Box, Button, Card, CardContent, Skeleton, Stack, Typography } from "@mui/material";
import axios from "axios";
import { ReactNode, useEffect, useState } from "react";
import { OrderInfo } from "../shared/orderInfo/types";
import { OrderInfoStack } from "../taskManagement/orderInfo/styles";
import Order from "./Order";
import Properties from "./Properties";

// stacked: phones show the order and property cards one above the other instead of side by side, with the
// order number moved to the page header and statusChip pinned to the order card's corner
const OrderDetails = ({
  orderInfo,
  isCondensed,
  stacked,
  statusChip
}: {
  orderInfo: OrderInfo | null;
  isCondensed: boolean;
  stacked?: boolean;
  statusChip?: ReactNode;
}) => {
  return (
    <>
      <Stack direction="row" marginBottom={0} sx={{ overflow: "auto" }}>
        <Card
          sx={{
            backgroundColor: isCondensed ? "rgba(0, 0, 0, 0.02)" : "transparent",
            borderRadius: 0,
            borderRight: isCondensed ? "1px solid rgba(0, 0, 0, 0.18)" : "none",
            boxShadow: 0,
            overflow: "auto",
            padding: 0,
            width: "100%",
            fontSize: { sm: "0.7rem", lg: "0.875rem" }
          }}
        >
          <CardContent sx={{ padding: 0 }} style={{ paddingBottom: 0 }}>
            <OrderInfoStack
              direction={isCondensed || stacked ? "column" : "row"}
              spacing={isCondensed ? 0 : stacked ? 2 : 3}
              isCondensed={isCondensed}
              // Both cards have fixed/max desktop widths and the property details size to their text;
              // stacked, they span the column
              sx={
                stacked
                  ? {
                      "& .customCard": { width: "auto", maxWidth: "none" },
                      "& .customCard > .MuiStack-root, & .customCard > .MuiStack-root > .MuiBox-root": { flex: 1, minWidth: 0 }
                    }
                  : undefined
              }
            >
              <Stack direction="column" sx={{ justifyContent: "space-between" }}>
                {!stacked && (
                  <Stack direction="row" alignItems="flex-start" className="customCard customCard-blue">
                    <Typography
                      sx={{
                        fontSize: { xs: "1rem", lg: "1.3rem" }
                      }}
                      fontWeight={600}
                      color="primary"
                    >
                      {orderInfo?.titleCode} {orderInfo?.number}
                      {!orderInfo && <Skeleton height={40} width={200} />}
                    </Typography>
                  </Stack>
                )}
                {stacked ? (
                  // The order grid's row spacing pulls it up 8px to tuck under the blue header; with no header that clips its top
                  <Box sx={{ position: "relative", "& > .customCard": { mt: 0 } }}>
                    <Order orderInfo={orderInfo} />
                    {statusChip && <Box sx={{ position: "absolute", top: 12, right: 12 }}>{statusChip}</Box>}
                  </Box>
                ) : (
                  <Order orderInfo={orderInfo}/>
                )}
              </Stack>
              <Properties orderInfo={orderInfo} alignActionsRight={stacked} />
            </OrderInfoStack>
          </CardContent>
        </Card>
      </Stack>
    </>
  );
};

export default OrderDetails;
